import React from 'react';
import {Input, Modal, Typography} from 'antd';

const {TextArea} = Input;
const {Paragraph} = Typography;

const MODAL_WIDTH = 760;
const TEXTAREA_PROPS = {
    autoSize: {minRows: 4, maxRows: 18},
};

const TranslationFormModal = ({
    open,
    mode = 'edit',
    translationKey = '',
    draftKey = '',
    draftValue = '',
    masterValue = '',
    onKeyChange,
    onValueChange,
    onSave,
    onClose,
}) => {
    const isAdd = mode === 'add';
    const isReadonly = mode === 'view';

    const modalTitle = isAdd ? 'Add new translation' : translationKey;
    const valueLabel = isAdd ? 'Translation value' : isReadonly ? 'Translation' : 'Edit translation';

    return (
        <Modal
            title={modalTitle}
            open={open}
            onOk={onSave}
            onCancel={onClose}
            okText={isReadonly ? 'Close' : isAdd ? 'Add translation' : 'Apply'}
            cancelButtonProps={isReadonly ? {style: {display: 'none'}} : undefined}
            width={MODAL_WIDTH}
            destroyOnClose
        >
            {masterValue && (
                <div className="translation-modal__master">
                    <div className="translation-modal__label">Estonian (master)</div>
                    <Paragraph className="translation-modal__master-text">{masterValue}</Paragraph>
                </div>
            )}

            {isAdd && (
                <>
                    <div className="translation-modal__label">Translation key</div>
                    <TextArea
                        {...TEXTAREA_PROPS}
                        value={draftKey}
                        onChange={(event) => onKeyChange(event.target.value.replace(/\s/g, ''))}
                        placeholder="translation.key"
                        autoSize={{minRows: 2, maxRows: 6}}
                        autoFocus
                    />
                </>
            )}

            <div className={`translation-modal__label${isAdd ? ' translation-modal__label--spaced' : ''}`}>
                {valueLabel}
            </div>
            <TextArea
                {...TEXTAREA_PROPS}
                value={draftValue}
                onChange={(event) => onValueChange(event.target.value)}
                readOnly={isReadonly}
                autoFocus={!isAdd && !isReadonly}
                placeholder={isAdd ? 'Translation text' : undefined}
            />
        </Modal>
    );
};

export default TranslationFormModal;
